// Статусы набора компетенций для задачи
export const CHECKPOINT_COMPETENCE_SET_STATUS_DEFAULT = 'default';
export const CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED = 'confirmed';
export const CHECKPOINT_COMPETENCE_SET_STATUS_REJECTED = 'rejected';
